<template>
  <v-app id="app">
    <app-header />
    <app-sidebar />
    <v-main>
      <!-- main content -->
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { inject, onMounted } from 'vue';
import AppHeader from '@/venit/app-header/app-header.vue';
import AppSidebar from '@/venit/app-sidebar/app-sidebar.vue';
import AccountService from '@/account/account.service';

const accountService = inject<() => AccountService>('accountService')!;

const PUBLIC_AUTH_ROUTES = ['/account/activate', '/account/password-reset', '/password/reset/request'];

onMounted(() => {
  const isPublicAuthRoute = PUBLIC_AUTH_ROUTES.some(p => window.location.pathname.startsWith(p));
  if (!isPublicAuthRoute) {
    accountService().retrieveProfiles();
  }
});
</script>
